import React from "react";
import { Box, Button, Paper, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { i18n } from "../../translate/i18n";
import { getModuleAccessMessage } from "../../helpers/moduleAccess";

const ModuleAccessDenied = ({ reason, onRetry }) => (
  <Box p={3}>
    <Paper variant="outlined">
      <Box p={3} role="status">
        <Typography variant="h6" gutterBottom>{i18n.t("moduleAccess.title")}</Typography>
        <Typography color="textSecondary">{getModuleAccessMessage(reason)}</Typography>
        <Box mt={2} display="flex" gridGap={12}>
          <Button component={Link} to="/tickets" color="primary">{i18n.t("moduleAccess.back")}</Button>
          <Button onClick={() => onRetry()}>{i18n.t("moduleAccess.retry")}</Button>
        </Box>
      </Box>
    </Paper>
  </Box>
);

export default ModuleAccessDenied;
